import { __assign, __extends } from "tslib";
import React from 'react';
import { SettingsTabLayoutContext } from '../SettingsTabLayoutContext';
var _DividerTab = /** @class */ (function (_super) {
    __extends(_DividerTab, _super);
    function _DividerTab() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _DividerTab.prototype.componentDidMount = function () {
        var addTab = this.props.addTab;
        var _a = addTab({
            type: 1 /* Divider */,
            props: {},
        }), removeTab = _a.removeTab, updateTab = _a.updateTab;
        this.removeTab = removeTab;
        this.updateTab = updateTab;
    };
    _DividerTab.prototype.componentWillUnmount = function () {
        if (this.removeTab) {
            this.removeTab();
        }
    };
    _DividerTab.prototype.render = function () {
        return null;
    };
    return _DividerTab;
}(React.Component));
export var DividerTab = function (props) {
    return (React.createElement(SettingsTabLayoutContext.Consumer, null, function (context) { return React.createElement(_DividerTab, __assign({}, props, { addTab: context.addTab })); }));
};
//# sourceMappingURL=DividerTab.js.map